import React, { ReactNode, useContext, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Cases from '../pages/Cases';
import { CaseContext } from '../providers/CaseProvider';
import { GET_CASE } from '../reducer';
import BackdropSpinner from './BackdropSpinner';

interface ITool {
	caseQuery: string;
	allCasesQuery: string;
	deleteMutation: string;
	partitionKey: string; //PartitionKeyEnum
	children: ReactNode;
}

/**
 * Wrapper component for loading and switching from case overview to cases
 * @param caseQuery specific case query to load via id
 * @param allCasesQuery to load all cases table
 * @param deleteMutation to delete single case by id
 * @param paritionKey to reference against queried case to signify successful load
 * @param children case overview component to render when case loaded
 */
const Tool = ({
	caseQuery,
	allCasesQuery,
	deleteMutation,
	partitionKey,
	children,
}: ITool) => {
	const { dispatch, state } = useContext(CaseContext);
	const caseData = state?.caseData;

	const [searchParams] = useSearchParams();
	// Supports depricated slugs
	const id = searchParams.get('id');

	// On page load, or when id changes, get case
	useEffect(() => {
		if (!id) return;
		dispatch({ type: GET_CASE, query: caseQuery, id });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [id]);

	const isCaseLoaded =
		caseData &&
		!!Object.keys(caseData).length &&
		caseData?.partitionKey === partitionKey;

	return (
		<>
			{id ? (
				<>{isCaseLoaded ? <>{children}</> : <BackdropSpinner />}</>
			) : (
				<Cases
					allCasesQuery={allCasesQuery}
					deleteMutation={deleteMutation}
				/>
			)}
		</>
	);
};

export default Tool;
